import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Loader from "@/components/Loader";
import EditableTable from "./CommonTable";

import {
  fetchReferralCreateList,
  setCreatedPage,
  setPageSize,
} from "@/slices/referralSlice/ReferralSlice";

import SimplePagination from "@/components/SimplePagination";
import PanelUserSearch from "@/components/PanelUserSearch";
import PageSizeSelector from "@/components/PageSizeSelector";

function ReferralCreated() {
  const dispatch = useDispatch();

  const {
    createdList,
    createdPage,
    pageSize,
    status,
  } = useSelector((state) => state.referralData);


  const [searchInput, setSearchInput] = useState("");

  // ✅ Headers
  const headers =
    createdList?.Create_Referal
      ?.length > 0
      ? Object.keys(createdList.Create_Referal
      [0]).filter((key) => key !== "id")
      : [];

  const hasData = createdList?.Create_Referal
    ?.length > 0;

  const isSearching = searchInput && searchInput.trim() !== "";



  // ✅ Initial + Page Change
  useEffect(() => {
    dispatch(fetchReferralCreateList({ page: createdPage, search: "" }));
  }, [dispatch, createdPage]);


  // ✅ Debounced Search
  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(fetchReferralCreateList({ page: 1, search: searchInput }));
      dispatch(setCreatedPage(1)); // reset page
    }, 600);

    return () => clearTimeout(timer);
  }, [searchInput]);


  // ✅ Page Size Change
  const handlePageSizeChange = (size) => {
    dispatch(setPageSize(size));
    dispatch(setCreatedPage(1));
    dispatch(fetchReferralCreateList({ page: 1, search: searchInput }));
  };

  // ✅ Loader
  if (status === "loading") {
    return (
      <div className="w-full pt-20 flex justify-center">
        <Loader />
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center p-1">

      {/* 🔍 Search */}
      <PanelUserSearch
        value={searchInput}
        onChange={setSearchInput}
      />

      <div className="w-full flex flex-col items-center">
        <div className="max-w-[95%] w-full">

          {/* ✅ Table OR Empty State */}
          {hasData ? (
            <EditableTable
              headers={headers}
              rows={createdList?.Create_Referal || []}
              hideChangeLog={true}
              hideAction={true}
            />
          ) : (
            <div className="w-full flex flex-col items-center justify-center py-20 text-gray-500">
              <div className="text-5xl mb-3">🔍</div>

              {searchInput ? (
                <>
                  <p className="text-lg font-medium">No results found</p>
                  <p className="text-sm mt-1">
                    for{" "}
                    <span className="font-semibold">
                      {searchInput}
                    </span>
                  </p>
                </>
              ) : (
                <>
                  <p className="text-lg font-medium">
                    No Data Available
                  </p>
                  <p className="text-sm mt-1">
                    There are no referrals to display
                  </p>
                </>
              )}
            </div>
          )}
        </div>


        {!(isSearching && !hasData) && (
          <div className="flex mt-4 items-center justify-between w-11/12">

            {/* Page Size */}
            <PageSizeSelector
              pageSize={pageSize}
              setPageSize={handlePageSizeChange}
            />

            <SimplePagination
              currentPage={createdPage}
              setCurrentPage={(page) =>
                dispatch(setCreatedPage(page))
              }
              totalPages={Math.ceil(
                (createdList?.pagination?.count || 0) / pageSize
              )}
            />

          </div>
        )}

      </div>
    </div>
  );
}

export default ReferralCreated;